import AIMS_FLAVORS from 'lib/aimsFlavors';

export const nineSlotLayout = {
  tease0: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_380x190,
        m: AIMS_FLAVORS.FOCAL_147x147,
        l: AIMS_FLAVORS.FOCAL_200x100,
        xl: AIMS_FLAVORS.FOCAL_260x130,
      },
      display: 'db dn-m dn-l',
    },
    headlineSizes: 'f7 f4-m f6-l f5-xl',
    headlineTextPositioning: 'pl4-m',
    mediaLabel: {
      eyebrowDisplay: 'db dn-m db-l',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn di-m',
    },
  },
  tease1: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_90x90,
      },
      display: 'db dn-m dn-l',
    },
    headlineSizes: 'f6 f4-m f6-l f5-xl',
    headlineTextPositioning: 'pl4-m',
    mediaLabel: {
      eyebrowDisplay: 'dn',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn di-m',
    },
  },
  tease2: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_90x90,
      },
      display: 'db dn-m dn-l',
    },
    headlineSizes: 'f6 f4-m f6-l f5-xl',
    headlineTextPositioning: 'pl4-m',
    mediaLabel: {
      eyebrowDisplay: 'dn db-m',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn di-m',
    },
  },
  tease3: {
    image: {
      sizes: {},
      display: 'dn dn-m dn-l',
    },
    headlineSizes: 'f6 f4-m f6-l f5-xl',
    headlineTextPositioning: 'pl4',
    mediaLabel: {
      eyebrowDisplay: 'db',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'di',
    },
  },
  tease4: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_380x190,
        m: AIMS_FLAVORS.FOCAL_200x100,
        l: AIMS_FLAVORS.FOCAL_200x100,
      },
      display: 'db dn-xl',
    },
    headlineSizes: 'f7 f5-m f6-l f5-xl',
    headlineTextPositioning: 'pl4-xl',
    mediaLabel: {
      eyebrowDisplay: 'db',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn di-xl',
    },
  },
  tease5: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_90x90,
        m: AIMS_FLAVORS.FOCAL_200x100,
        l: AIMS_FLAVORS.FOCAL_200x100,
      },
      display: 'db dn-xl',
    },
    headlineSizes: 'f6 f5-m f6-l f5-xl',
    headlineTextPositioning: 'pl4-xl',
    mediaLabel: {
      eyebrowDisplay: 'db',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn di-xl',
    },
  },
  tease6: {
    image: {
      sizes: {
        s: AIMS_FLAVORS.FOCAL_90x90,
        m: AIMS_FLAVORS.FOCAL_200x100,
        l: AIMS_FLAVORS.FOCAL_200x100,
      },
      display: 'db dn-xl',
    },
    headlineSizes: 'f6 f5-m f6-l f5-xl',
    headlineTextPositioning: 'pl4-xl',
    mediaLabel: {
      eyebrowDisplay: 'db',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'dn di-xl',
    },
  },
  tease7: {
    image: {
      sizes: {
        m: AIMS_FLAVORS.FOCAL_200x100,
        l: AIMS_FLAVORS.FOCAL_200x100,
      },
      display: 'dn db-m dn-xl',
    },
    headlineSizes: 'f6 f5-m f6-l f5-xl',
    headlineTextPositioning: 'pl4 pl0-m pl4-xl',
    mediaLabel: {
      eyebrowDisplay: 'db',
      iconBlockDisplay: 'db',
      iconInlineDisplay: 'di dn-m di-xl',
    },
  },
};
